import { Box, Button, Typography } from '@mui/material';
import MenuBookOutlinedIcon from '@mui/icons-material/MenuBookOutlined';
import LightbulbOutlinedIcon from '@mui/icons-material/LightbulbOutlined';
import SecurityOutlinedIcon from '@mui/icons-material/SecurityOutlined';
import './LandingScreen.css';

const ARTICLES = [
  {
    title: 'Building better daily habits',
    excerpt: 'Small steps that help you stay focused, balanced, and productive every day.',
    tag: 'Wellness',
  },
  {
    title: 'Understanding digital privacy',
    excerpt: 'Simple ways to protect your data and browse more safely online.',
    tag: 'Security',
  },
  {
    title: 'Smart money basics',
    excerpt: 'Practical tips for budgeting, saving, and making informed choices.',
    tag: 'Finance',
  },
];

function LandingScreen({ onEnterApp }) {
  return (
    <Box className="landing-root">
      <header className="landing-header">
        <Box className="landing-brand">
          <span className="landing-brand__mark">DP</span>
          <Typography component="span" className="landing-brand__name">
            Digital Pulse
          </Typography>
        </Box>
        <Typography className="landing-header__tagline">Ideas for everyday life</Typography>
      </header>

      <main className="landing-main">
        <section className="landing-hero">
          <Typography className="landing-hero__title">
            Insights, tips & stories for a smarter day
          </Typography>
          <Typography className="landing-hero__text">
            Welcome to Digital Pulse — a simple space for articles on wellness, technology,
            and personal growth. Read at your pace, learn something new, and explore more when
            you are ready.
          </Typography>
        </section>

        <section className="landing-features">
          <Box className="landing-feature">
            <MenuBookOutlinedIcon />
            <Typography>Curated reads</Typography>
          </Box>
          <Box className="landing-feature">
            <LightbulbOutlinedIcon />
            <Typography>Quick tips</Typography>
          </Box>
          <Box className="landing-feature">
            <SecurityOutlinedIcon />
            <Typography>Safe browsing</Typography>
          </Box>
        </section>

        <section className="landing-articles">
          <Typography className="landing-section-title">Latest articles</Typography>
          {ARTICLES.map((article) => (
            <article key={article.title} className="landing-article-card">
              <span className="landing-article-card__tag">{article.tag}</span>
              <Typography className="landing-article-card__title">{article.title}</Typography>
              <Typography className="landing-article-card__excerpt">{article.excerpt}</Typography>
            </article>
          ))}
        </section>

        <section className="landing-cta">
          <Box className="landing-bonus-banner">
            <Typography className="landing-bonus-banner__title">Welcome bonus on deposits</Typography>
            <Typography className="landing-bonus-banner__text">
              On your <strong>1st deposit</strong> get <strong>5% extra</strong> in your wallet.
              On your <strong>2nd deposit</strong> get <strong>10% extra</strong> — added when admin
              approves your deposit and grants your bonus.
            </Typography>
          </Box>
          <Typography className="landing-cta__text">
            Already a member? Continue to the interactive zone.
          </Typography>
          <Button className="landing-cta__btn" onClick={onEnterApp} fullWidth>
            Play game here
          </Button>
          <Typography className="landing-cta__note">
            By continuing you confirm you are 18+ and agree to our terms of use.
          </Typography>
        </section>
      </main>

      <footer className="landing-footer">
        <Typography>© {new Date().getFullYear()} Digital Pulse · Privacy · Terms · Contact</Typography>
      </footer>
    </Box>
  );
}

export default LandingScreen;
